<template>
  <v-container class="pa-0 ma-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <div class="pt-4">
      <v-card outlined>
        <!-- form  -->
        <v-card-text>
          <v-row class="ma-0 pa-0">
            <!-- form  -->
            <v-col class="ma-0 pa-0" cols="12" md="6">
              <v-row class="mb-0 pb-0">
                <!-- toggle  -->
                <v-col style="overflow: auto" cols="12" md="12">
                  <v-btn-toggle
                    @change="searchByChange()"
                    mandatory
                    v-model="searchBy"
                  >
                    <v-btn
                      v-if="showFizToggle"
                      :class="getForAccessibility ? ' btn-for-disabled ' : ''"
                      active-class="active-btn-group-item"
                      small
                      value="FIZ"
                    >
                      <v-icon style="padding-right: 4px">mdi-account</v-icon>
                      <span>{{ $t('Fizinis asmuo') }}</span>
                    </v-btn>
                    <v-btn
                      v-if="showJurToggle"
                      :class="getForAccessibility ? ' btn-for-disabled ' : ''"
                      active-class="active-btn-group-item"
                      small
                      value="JUR"
                    >
                      <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                      <span>{{ $t('Juridinis asmuo') }}</span>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col  class="py-0" cols="12" v-if="pageError">
                  <span class="page-error-msg">{{pageError}}</span>
                </v-col>
                <!-- FIZ card  -->
                <template v-if="showFiz">
                  <v-col class="pb-0" cols="12" md="6">
                    <el-text-field
                      required
                      label="Fizinio asmens kodas"
                      tooltip="Vieša paieška. Paieška. Fizinio asmens kodas"
                      v-model="formData.code"
                      validateKey="FIZ_code"
                      key="FIZ_code"
                      :cMask="11"
                      :length="11"
                    />
                  </v-col>
                </template>
                <!-- JUR card  -->
                <template v-if="showJur">
                  <v-col class="pb-0" cols="12" md="6">
                    <el-text-field
                      required
                      label="Juridinio asmens kodas"
                      tooltip="Vieša paieška. Paieška. Juridinio asmens kodas"
                      v-model="formData.code"
                      :cMask="9"
                      :length="9"
                      validateKey="JUR_code"
                      key="JUR_code"
                    />
                  </v-col>
                </template>
                <!-- data -->
                <v-col v-if="showPp" class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Prokūros kodas"
                    tooltip="Vieša paieška. Paieška. Prokūros kodas"
                    v-model="formData.mandate_code"
                    :cMask="10"
                    :length="10"
                    validateKey="pp_id_code"
                    key="pp_id_code"
                  />
                </v-col>
                <v-col v-if="showItpsi" class="pb-0" cols="12" md="6">
                  <el-text-field
                    required
                    label="Įgaliojimo kodas"
                    tooltip="Vieša paieška. Paieška. Įgaliojimo kodas"
                    v-model="formData.mandate_code"
                    :cMask="10"
                    :length="10"
                    validateKey="FIZ_id_code"
                    key="FIZ_id_code"
                  />
                </v-col>
                <v-col  class="py-0 my-0" cols="12" md="12">
                    <el-radio-group
                      class="mt-3 mb-4"
                      label="parameterType"
                      v-model="formData.parameterType"
                      :items="parameterType"
                      inline
                      required
                    >
                    </el-radio-group>
                  </v-col>
                 <v-col  v-if="showPdf" class="pb-0" cols="12" md="12">
                  <a ref="pdfCol"/>
                  <el-PDF-viewer @progress="getProgress" download :file="pdfFile" />
                </v-col>
                <v-col class="pb-0" cols="12" md="12" style="display: flex;">
                  <d-recaptcha :loading="loading" title="Ieškoti" @verifyData="searchData" />
                  <el-button
                    title="Išvalyti"
                    color="secondary"
                    :loading="loading"
                    @click.native="clearData()"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
// #RECAPTCHA_OFF
import DRecaptcha from '@/components/recaptcha/DRecaptcha'
import Enums from '@/enums'
import { mapGetters } from 'vuex'

export default {
  name: 'PublicSearchForm',
  components: {
    // #RECAPTCHA_OFF
    DRecaptcha,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageError: "",
      formData: {},
      verifyData: [],
      pageloading: false,
      loading: false,
      searchBy: null,
      classifiers: {},
      enumsClassifiers: {},
      files: {},
      uploadedFiles: {},
      pdfFile: {},
      scrollPos: false
    }
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    showPp() {
      return this.formData.parameterType =='ITPSP-PP'
    }, 
    showItpsi() {
      return this.formData.parameterType =='ITPSI'
    }, 
     showPdf() {
      return Object.keys(this.pdfFile).length != 0
    },
    showFizToggle() {
      return true
    },
    showJurToggle() {
      return true
    },
    showDatToggle() {
      return true
    },
    showFiz() {
      return this.searchBy === 'FIZ'
    },
    showJur() {
      return this.searchBy === 'JUR'
    },
    parameterType() {
      return [
        { 
          label: this.$t('Elektroninis įgaliojimas'),
          value: 'ITPSI',
        },
        { 
          label: this.$t('Prokūra'),
          value: 'ITPSP-PP',
        }
      ]
    },
    modeReadonly() {
      return false
    },
  },
  beforeDestroy() {},
  created() {
    this.enumsClassifiers = Enums
  },
  methods: {
    getProgress(progress){
      if(progress == 1 && this.showPdf && !this.scrollPos){
          const top = this.$refs.pdfCol.getBoundingClientRect().top
          this.scrollPos = true;
          this.$nextTick(() => {
            this.$nextTick(() => {
              window.scrollTo(0, top);
            }) 
          })
      }
    },
    verifyDataResp(response) {
      this.verifyData = response
    },
    searchByChange() {
      this.clearData();
      this.$set(this.formData, 'code', '')
    },
    clearData() {
      this.loading = true
      this.formData = {}
      this.pdfFile = {}
      this.pageError = ""
      this.verifyData = []
      this.scrollPos = false
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
          this.loading = false
        })
      })
    },
    searchData(verifyRecaptcha) {
      this.$validator.validateAll().then((res) => {
        // #RECAPTCHA_OFF
        if (res && verifyRecaptcha) {
        // if (res) {
          this.loading = true
          this.pdfFile = {}
          let formData = {}
          this.scrollPos = false
          formData.person_type = this.searchBy
          formData.object_types = this.formData.parameterType
          formData.person_code = this.formData.code
          formData.code = this.formData.mandate_code
          formData.lang = this.$store.getters.getSystemLang
          // #RECAPTCHA_OFF
          formData.recaptcha = verifyRecaptcha
          let url = `public-search/search`
          this.$axios
            .post(url, formData)
            .then((res) => {
              if(res.data.on_page){
                this.pageError = res.data.message
              } else {
                 this.pageError = ""
              }
              if(res.data.message){
               this.$root.$emit('DATA_OK', res.data.message)
              }
              if(res.data.file){
                this.clearData()
                this.pdfFile = res.data
                this.pdfFile.original_filename = 'Peržiūra.pdf'
              }
            })
            .catch((err) => {
              if(err.response.data.on_page){
                this.pageError = err.response.data.message
                window.scrollTo(0, 0);
              } else {
                this.pageError = ""
                this.$root.$emit('DATA_ERROR_TEXT', err.response.data.message)
              }
            })
            .finally(() => {
              this.verifyData = []
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.page-error-msg{
  color: red;
  font-size: 15px;
}
.btn-for-disabled{
  color: black !important;
  background-color: #d6d6d6 !important;
}
</style>
